import { TabPanel, TabView } from 'primereact/tabview';
import { FC, useState } from 'react';
import { ButtonsSection } from '../components/ButtonsSection';
import { CustomComponentsSection } from '../components/CustomComponentsSection';
import { DataDisplaySection } from '../components/DataDisplaySection';
import { DesignTokensSection } from '../components/DesignTokensSection';
import { FeedbackStatesSection } from '../components/FeedbackStatesSection';
import { InputComponentsSection } from '../components/InputComponentsSection';
import { LayoutPatternsSection } from '../components/LayoutPatternsSection';
import { NavigationSection } from '../components/NavigationSection';
import { OverlaysSection } from '../components/OverlaysSection';
import { TypographyUtilitiesSection } from '../components/TypographyUtilitiesSection';

const StyleGuidePage: FC = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const sections = [
    {
      id: 'design-tokens',
      label: 'Design Tokens',
      component: DesignTokensSection,
    },
    {
      id: 'buttons',
      label: 'Buttons',
      component: ButtonsSection,
    },
    {
      id: 'input-components',
      label: 'Input Components',
      component: InputComponentsSection,
    },
    {
      id: 'data-display',
      label: 'Data Display',
      component: DataDisplaySection,
    },
    {
      id: 'navigation',
      label: 'Navigation',
      component: NavigationSection,
    },
    {
      id: 'overlays',
      label: 'Overlays',
      component: OverlaysSection,
    },
    {
      id: 'feedback-states',
      label: 'Feedback & States',
      component: FeedbackStatesSection,
    },
    {
      id: 'layout-patterns',
      label: 'Layout Patterns',
      component: LayoutPatternsSection,
    },
    {
      id: 'custom-components',
      label: 'Custom Components',
      component: CustomComponentsSection,
    },
    {
      id: 'typography-utilities',
      label: 'Typography & Utilities',
      component: TypographyUtilitiesSection,
    },
  ];

  return (
    <div className='flex gap-6 min-h-screen bg-gray-50'>
      {/* Main Content */}
      <main className='flex-1 p-8 max-w-6xl'>
        <div className='mb-8'>
          <h1 className='text-4xl font-bold text-gray-900 mb-2'>
            Application Style Guide
          </h1>
          <p className='text-lg text-gray-600'>
            A comprehensive showcase of UI components, design tokens, and
            patterns used throughout the application.
          </p>

          <p className='text-lg text-gray-600'>
            Disclaimer: this page is intended for development and design
            reference. It is only available to admins, and it does not support
            translations.
          </p>
        </div>

        <TabView
          activeIndex={activeIndex}
          onTabChange={e => setActiveIndex(e.index)}
          pt={{
            nav: {
              style: {
                overflowX: 'auto',
                overflowY: 'hidden',
                scrollbarWidth: 'thin',
              },
            },
          }}
        >
          {sections.map(section => {
            const SectionComponent = section.component;
            return (
              <TabPanel key={section.id} header={section.label}>
                <SectionComponent />
              </TabPanel>
            );
          })}
        </TabView>

        <div className='mt-12 pt-8 border-t border-gray-200'>
          <p className='text-sm text-gray-500 text-center'>
            This style guide showcases all UI components and design patterns
            used in the Mindmixer application.
          </p>
        </div>
      </main>
    </div>
  );
};

export default StyleGuidePage;
